export default "__VITE_ASSET__DrtbKmXS__"